var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container",class:_vm.classes,style:({ backgroundColor: 'var(--tokens-surface)', marginTop: `${_vm.topMargin}px` })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }